import {SchedulerSettingsResponse, SchedulerSettingsResponseItem} from '@/types/service-response'

export class SchedulerSettings {
  private constructor (
    readonly code: string,
    readonly value: boolean,
    readonly value2: string,
    readonly description: string,
    readonly children: SchedulerSettings[]
  ) {}

  public static createListFromResponse (data: SchedulerSettingsResponse): SchedulerSettings[] {
    const mrowFound: SchedulerSettingsResponseItem | undefined = data.find((item: SchedulerSettingsResponseItem) => item.Code === 'MROW')
    if(mrowFound) {
      data.splice(data.indexOf(mrowFound), 1)
    }

    const filteredData: SchedulerSettingsResponseItem[] =  []
    data.forEach((item: SchedulerSettingsResponseItem) => {
      const foundItem: SchedulerSettingsResponseItem | undefined = filteredData.find((i: SchedulerSettingsResponseItem) => i.Code === item.Code)
      if(foundItem && item.Mitarbeiter !== 0) {
        const index: number = filteredData.indexOf(foundItem)
        filteredData[index] = item
      } else {
        filteredData.push(item)
      }
    })
    return filteredData.map((item: SchedulerSettingsResponseItem): SchedulerSettings => {
      return new SchedulerSettings(
        item.Code,
        item.SettingValue === '1',
        item.SettingValue,
        item.Bezeichnung,
        item.Code === 'FULLD' && mrowFound ? [new SchedulerSettings(mrowFound.Code, mrowFound.SettingValue !== '1', mrowFound.SettingValue, mrowFound.Bezeichnung,[])] : []
      )
    })
  }
}
